import { Navigate, useParams } from 'react-router-dom';

import store from '../redux/store';

import Users from './adminSystem/UsersComponent';
import UserNew from './adminSystem/UserNewComponent';
import UserManagement from './adminSystem/UserManagementComponent';
import SysUsers from './adminSystem/SysUsersComponent';
import SysUserNew from './adminSystem/SysUserNewComponent';
import SysUserManagement from './adminSystem/SysUserManagementComponent';

import { RefreshClientsCachedData, RefreshUsersCachedData } from './AFStoreDataRefresh';
import { RefreshEmployersByEIDCachedData, RefreshEmployersByCIDCachedData, RefreshWorksiteByCIDCachedData, RefreshWorksiteByEIDCachedData } from './AFStoreDataRefresh';
import * as AFStateHelper from './AFStateHelper';
import { DispatchAF } from './AFStoreDispatchAction';
import * as Consts from './constants/Consts';
import { ClientType } from "./constants/Consts";
import * as ReduxDataStatus from '../utils/constants/ReduxDataStatus';


export const UsersPage = () => {
    const reduxStore = store.getState();

    var dataStatus;
    if( reduxStore.clients.status === ReduxDataStatus.LOADING || reduxStore.clients.status === ReduxDataStatus.IDLE ) {
        
        dataStatus = ReduxDataStatus.LOADING;
    }
    else {
        dataStatus = ReduxDataStatus.SUCCEEDED;
    }

    return (
        <Users
            loadComponentData={UsersDataLoader}
            dataStatus={dataStatus}
            users={reduxStore.users}
            clients={reduxStore.clients}
        />
    );
}

const UsersDataLoader = () => {
    RefreshClientsCachedData();
    const contextClientId = AFStateHelper.getContextClientId();
    RefreshUsersCachedData(contextClientId);
}


export const UserNewPage = () => {
    const reduxStore = store.getState();

    const contextClient = AFStateHelper.getContextClient();

    return (
        <UserNew
            loadComponentData={UserDataLoader}
            postUser={DispatchAF.postUser}
            mostRecentUserId={reduxStore.bucket.bucket.mostRecentUserId}
            dataStatus={reduxStore.users.status}
            client={contextClient}
            employers={reduxStore.employers.employers}
            worksites={reduxStore.worksites.worksites}
        />
    );
}

export const UserManagementPage = () => {
    const reduxStore = store.getState();

    const { userId } = useParams();
    const uId = parseInt(userId, 10);

    const contextClient = AFStateHelper.getContextClient();

    return (
        <UserManagement
            loadComponentData={UserDataLoader}
            user={reduxStore.users.users.find((user) => (user.id === uId))}
            dataStatus={reduxStore.users.status}
            patchUser={DispatchAF.patchUser}
            client={contextClient}
            employers={reduxStore.employers.employers}
            worksites={reduxStore.worksites.worksites}
        />
    );
};


// should we pass the clientId down form UserNew component????
const UserDataLoader = () => {
    const refreshingData = RefreshClientsCachedData();         // do we really need this? Do we need to guard against data in Loading state?

    if(!refreshingData) {
        const contextClientId = AFStateHelper.getContextClientId();
        const clientType = AFStateHelper.getClientType(contextClientId);

        if(clientType === ClientType.Angajator) {
            const myEmployerId = AFStateHelper.getClientEmployerEID(contextClientId);

            RefreshEmployersByEIDCachedData(myEmployerId);
            RefreshWorksiteByEIDCachedData(myEmployerId);
        }
        else if(clientType === ClientType.ServicuExtern) {
            RefreshEmployersByCIDCachedData(contextClientId);
            RefreshWorksiteByCIDCachedData(contextClientId);
        }
        // else -> we should not be here.....
    }
}

/// CorEvo Users
export const SysUsersPage = () => {
    const reduxStore = store.getState();

    return (
        <SysUsers
            loadComponentData={SysUsersDataLoader}
            users={reduxStore.users}
            clients={reduxStore.clients}
        />
    );
}

const SysUsersDataLoader = () => {
    RefreshUsersCachedData(Consts.COREVO_CLIENT_ID);
}

export const SysUserManagementPage = () => {
    const reduxStore = store.getState();

    const { userId } = useParams();
    const uId = parseInt(userId, 10);

    return (
        <SysUserManagement
            user={reduxStore.users.users.find((user) => (user.id === uId))}
            dataStatus={reduxStore.users.status}
            patchUser={DispatchAF.patchUser}
        />
    );
};


export const SysUserNewPage = () => {
    const reduxStore = store.getState();

    if(reduxStore.bucket.bucket.mostRecentUserId != null) {
        return(
            <Navigate to={`/sysusers/${reduxStore.bucket.bucket.mostRecentUserId}`} replace />
        );
    }

    return (
        <SysUserNew
            postUser={DispatchAF.postUser}
        />
    );
}
